module.exports = __webpack_public_path__ + "static/media/logo-begross.5bc6ae6a.svg";